export const environment = {
  production: false,
  enableRoleTesting: true,
  showGasForm: true,
  showETSForm: true,
  showGenerationForm: false,
  showRealEstateForm: true
  };
  